import { isPlatform } from '@ionic/react';
// Constants
import { APP_CONFIG } from '../constants';
import { getCookieByKey } from './storage.helper';

export const extractConfigPage = (location) => {

    const pageKey = Object.keys(APP_CONFIG.PAGES).find(key => {

        if (APP_CONFIG.PAGES[key].path === undefined) {

            APP_CONFIG.PAGES[key].path = '';
        }

        return location.pathname.toUpperCase().indexOf(APP_CONFIG.PAGES[key].path.toUpperCase()) >= 0;

    });
    const pageConfig = APP_CONFIG.PAGES[pageKey];

    return pageConfig ? pageConfig : '';

};

/**
 * Indica si la aplicación se está usando desde la web
 */
export const isWeb = () => {

    // return false;
    return !isNative() && !isPlatform('mobileweb');
}
/**
 * Indica si la aplicación se está usando desde la web
 */
export const isWebView = () => {
    return getCookieByKey('platform') === 'mobile';
}

/**
 * Indica si la aplicación se está usando desde el navegador de un mobile
*/
export const isMobileWeb = () => {

    // return false;
    return !isNative() && isPlatform('mobileweb');
}

/**
 * Indica si la aplicación se está usando desde un entorno nativo
*/
export const isNative = () => {

    // return true;
    return getCookieByKey('platform') === 'mobile';
    // return isPlatform('cordova') || isPlatform('capacitor');
}

/**
 * Indica si la aplicación se está usando desde un dispositivo android
 */
export const isAndroid = () => {

    // return true;
    return getCookieByKey('platform') === 'mobile' && isPlatform('android') && isPlatform('capacitor') && isPlatform('cordova') && isPlatform('mobile');
}

/**
 * Indica si la aplicación se está usando desde un dispositivo IOS
 */
export const isIOS = () => {

    return getCookieByKey('platform') === 'mobile' && isPlatform('ios') && isPlatform('capacitor') && isPlatform('cordova') && isPlatform('mobile');
}